import { useState, useEffect } from "react";
import PlaceholderImg from "../img/placeholderImg.png";

const useClubs = (initialData) => {
  const [clubs, setClubs] = useState(initialData);
  const databaseUrl = process.env.REACT_APP_DATABASE_URL;

  useEffect(() => {
    const fetchClubs = async () => {
      try {
        const response = await fetch(databaseUrl);
        const data = await response.json();
        const filteredClubs = data.map((club) => ({
          handle: club.handle,
          name: club.name,
          logo: club.logo ? club.logo : PlaceholderImg,
          pro: club.pro,
        }));
  
        setClubs(filteredClubs);
      } catch (error) {
        console.error("Error fetching clubs:", error);
      }
    };

    if (clubs === undefined) {
      fetchClubs();
    }
  }, [clubs, databaseUrl]);

  return clubs;
};

export default useClubs; 